module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bloc full-width-bloc bgc-white l-bloc"
  }, [_c('div', {
    staticClass: "container bloc-sm"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', [_c('h5', {
    staticClass: "mg-md"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'bids-open.index',
        params: {
          projectId: this.$store.state.route.params.projectId
        }
      }
    }
  }, [_c('span', {
    staticClass: "ion ion-arrow-left-c icon-spacer"
  }), _vm._v("\tTakaisin tarjouspyyntöihin\n\t\t\t\t\t\t\t\t\t\t")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('router-link', {
    staticClass: "btn btn-lg inverse-color",
    attrs: {
      "to": {
        name: 'bidders.index'
      },
      "active-class": "btn-midnight-blue"
    }
  }, [_c('span', {
    staticClass: "ion ion-ios-people icon-spacer"
  }), _vm._v(" Toimittajat\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-lg btn-d inverse-color",
    attrs: {
      "to": {
        name: 'inner-basics.index'
      },
      "active-class": "btn-midnight-blue"
    }
  }, [_c('span', {
    staticClass: "ion ion-checkmark icon-spacer"
  }), _vm._v(" Perustiedot\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-lg btn-d inverse-color",
    attrs: {
      "to": {
        name: 'inner-files.index'
      },
      "active-class": "btn-midnight-blue"
    }
  }, [_c('span', {
    staticClass: "ion ion-folder icon-spacer"
  }), _vm._v(" Tiedostot\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-lg btn-d inverse-color",
    attrs: {
      "to": {
        name: 'inner-preview.index'
      },
      "active-class": "btn-midnight-blue"
    }
  }, [_c('span', {
    staticClass: "ion ion-ios-eye icon-spacer"
  }), _vm._v(" Esikatselu\n\t\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  })])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-bb1e3c5a"}!./src/app/components/inner-navbar/inner-navbar.html
// module id = 498
// module chunks = 1